function categoryMove(){
    if($('.category__secondDescription img').length>0){
       // $('.category-top h1').attr('style', 'background:url("/user/documents/upload/bannery/kategorie/titlebg.png"), url("'+$('.category__secondDescription img').attr('src')+'")')
        $('#category-header').prepend('<span class="sortButton">Seřadit</span>');
       // $('.category-top').addClass('haveImage')
    }
}

function strankovani() {
    if ($('.pagination-wrapper .pagination').length > 0) {
        let current_page;
        const strongCurrent = $('.pagination-wrapper .pagination strong.current');
    
        if (strongCurrent.length > 0) {
            current_page = parseFloat(strongCurrent.text());
        } else {
            // Pokud nejsme schopni získat current_page z `strong.current`, použijeme poslední stránku jako current_page
            current_page = parseFloat($('.pagination-wrapper .pagination a').last().text());
        }
    
        const last_page = parseFloat($('.pagination-wrapper .pagination a').last().text());
        const base_path = location.pathname.includes(':') ? location.pathname.split(':')[0] : location.pathname.replace(/strana-\d+\/?$/, '');
    
        const addPaginationLinks = (start, end, increment, beforeElementClass) => {
            for (let i = start; i !== end; i += increment) {
                if (i > 1 && i < last_page) {
                    const pageUrl = `${base_path}strana-${i}/`;
                    $(`.pagination-wrapper .pagination .${beforeElementClass}`).before(`<a class="custom_pagination pagination-link" href="${pageUrl}">${i}</a>`);
                }
            }
        };
    
        if (current_page === 1) {
            addPaginationLinks(current_page + 1, current_page + 5, 1, 'next');
        } else if (current_page === last_page) {
            addPaginationLinks(current_page - 1, current_page - 6, -1, 'prev');
        } else {
            addPaginationLinks(current_page + 1, current_page + 2, 1, 'next');
            addPaginationLinks(current_page - 1, current_page - 2, -1, 'prev');
        }
    }
    
    
    
    
}


$('html').on('click', '.sortButton', function(){
    $(this).next('form').slideToggle()
})

$(document).ready(function() {
    categoryMove();
    strankovani();
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    categoryMove();
    strankovani();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    categoryMove();
    strankovani();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    categoryMove();
    strankovani();
});